<style src="./HeaderPanel.scss" lang="scss"></style>
<template>
  <tr class="filter-header">
    <th
      scope="row"
      colspan="16"
      class="header-panel">
      <section class="content">
        <input
          type="text"
          v-model="filterList.searchText"
          v-debounce="300"
          @debounced="filterByText"
          placeholder="Busque pelo número do item ou descrição"
          class="searchtext cp1-small-textbox" />

        <div class="status">
          <button
            @click="filterByNotAssociated"
            :class="{ 'cp1-button__active': filterList.wasNotAssociated }"
            class="cp1-small-button">
            NÃO ASSOC.
          </button>
          <button
            @click="filterByAssociated"
            :class="{ 'cp1-button__active': filterList.wasAssociated }"
            class="cp1-small-button">
            ASSOCIADOS
          </button>
          <button
            @click="filterByQuoted"
            :class="{ 'cp1-button__active': filterList.wasQuoted }"
            class="cp1-small-button">
            COTADOS
          </button>
          <button
            @click="filterByProposal"
            :class="{ 'cp1-button__active': filterList.haveProposal }"
            class="cp1-small-button">
            COM VENDA
          </button>
        </div>

        <manipulate-sale
          class="gridbox sale" />
        <manipulate-minimum
          class="gridbox minimum" />
        <select-associated
          class="gridbox selectassociated" />
      </section>
    </th>
    <th colspan="10"></th>
  </tr>
</template>

<script>
import {DebounceDirective} from '@/components/primitives/helpers/debounce/Debounce'
import ManipulateSale from '../manipulate-sale/ManipulateSale'
import ManipulateMinimum from '../manipulate-minimum/ManipulateMinimum'
import SelectAssociated from '../select-associated/SelectAssociated'

export default {
  name: 'HeaderPanel',
  components: {
    ManipulateSale,
    ManipulateMinimum,
    SelectAssociated
  },
  directives: {
    debounce: DebounceDirective
  },
  props: {
    filters: {
      default: () => ({
        searchText: '',
        wasNotAssociated: false,
        wasAssociated: false,
        wasQuoted: false,
        haveProposal: false
      })
    }
  },
  data: () => ({
    filterList: {
      searchText: '',
      wasNotAssociated: false,
      wasAssociated: false,
      wasQuoted: false,
      haveProposal: false
    }
  }),
  watch: {
    filters: {
      handler () {
        this.filterList.searchText = this.filters.searchText
        this.filterList.wasNotAssociated = this.filters.wasNotAssociated
        this.filterList.wasQuoted = this.filters.wasQuoted
        this.filterList.wasAssociated = this.filters.wasAssociated
        this.filterList.haveProposal = this.filters.haveProposal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    filterByText () {
      this.$emit('change-filter', this.filterList)
    },
    filterByNotAssociated () {
      this.filterList.wasNotAssociated = !this.filterList.wasNotAssociated
      this.$emit('change-filter', this.filterList)
    },
    filterByQuoted () {
      this.filterList.wasQuoted = !this.filterList.wasQuoted
      this.$emit('change-filter', this.filterList)
    },
    filterByAssociated () {
      this.filterList.wasAssociated = !this.filterList.wasAssociated
      this.$emit('change-filter', this.filterList)
    },
    filterByProposal () {
      this.filterList.haveProposal = !this.filterList.haveProposal
      this.$emit('change-filter', this.filterList)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/header-panel/HeaderPanel.vue